import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export const sentryConfig = () => {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}